import { Bugsnag } from "./index"
import { warning } from "../alert"

export const apolloError = err => {
  const { graphQLErrors, networkError } = err
  let messages = []

  warning()
  if (!!graphQLErrors?.length) {
    messages = graphQLErrors?.reduce((prev, current) => [...prev, current.message], [])
  } else {
    const errors = networkError?.result?.errors
    messages = errors?.reduce((prev, current) => [...prev, current.message], [])
  }

  Bugsnag.notify(new Error(messages))
  Bugsnag.notify(err)
  console.error("GraphqlError", err)
  console.error(messages)
}
